export enum BatchResponseStatusEnum {
    success = 'Success',
    partiallySuccess = 'PartiallySuccess',
    failure = 'Failure',
}
